
import {
  Progress,
  Tabs,
  TabPane,
  Button,
  Select,
  Option,
  Checkbox,
  Tooltip,
} from 'element-ui';
import {
  PackageIcon,
  CreditCardIcon,
  HomeIcon,
  MapPinIcon,
  PlusIcon,
  ClockIcon,
  ChevronLeftIcon,
} from 'vue-feather-icons';
import CartItems from '@/pages/cart/components/CartItems.vue';
import AddressDeliveryInvoice from '@/pages/cart/components/AddressDeliveryInvoice.vue';
import TotalOrder from '@/pages/cart/components/TotalOrder.vue';
import CardInfo from '@/pages/cart/components/CardInfo.vue';
import DeliverySelected from '@/pages/cart/components/DeliverySelected.vue';
import TunnelOrderLayout from './TunnelOrderLayout.vue';
import AddessForm from '../../account/components/AddessForm.vue';
import DeliveryTabs from '@/pages/cart/components/DeliveryTabs.vue';
import MiniCart from '@/pages/cart/components/MiniCart.vue';
import ErrorsMsgs from '../../../components/ErrorsMsgs.vue';
import addressMixin from '@/mixins/addressMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import RegisterFormInfoGuest from '@/pages/authenticate/components/RegisterFormInfoGuest.vue';
import CodePromo2 from './CodePromo2.vue';

export default {
  mixins: [addressMixin, carriersMixin, cartMixin],
  data() {
    return {
      valide: true,
      addressesError: false,
      optioDeliveryError: false,
      showDelivery: true,
      isOpenAddAddress: false,
    };
  },
  computed: {
    carrier() {
      return this.cart?.Shipping?.Carrier;
    },
    guestUser() {
      return this.$store.state.user.guest.guestUser;
    },

    isLogin() {
      return this.$auth.loggedIn || this.guestUser;
    },
    deliveryFees() {
      const deliveryFeesTaxIncl = this.cart.Total.Shipping.TaxIncl;
      return deliveryFeesTaxIncl;
      //return 0;
    },
    valideAddress() {
      if (!this.getAddressDelivery?.MobilePhone) {
        return false;
      }
      if (!this.hasOtherInvoiceAddress) {
        return this.getAddressDelivery !== null;
      } else {
        return (
          this.getAddressDelivery !== null && this.getAddressInvoice !== null
        );
      }
    },
  },
  created() {
    if (this.isLogin) {
      this.fetchAddresses();
    }
  },
  mounted() {},
  methods: {
    validateAddress($event) {
      this.valide = $event.valide;
    },
    onRegisterFormInfoGuest() {
      this.fetchAddresses();
      if (process.client) {
        if (this.$SETTINGS.isMobile) {
          window.scrollTo(0, 0);
        }
      }
    },
    fetchAddresses() {
      this.addressService.fetchAddresses({
        onSuccess: (data) => {
          this.isOpenAddAddress = this.addresses?.length === 0;
          if (!this.isDigitalCart) {
            this.carriersService.fetchCarrierTypes({
              idAddress: this.idAddressDelivery,
              idCart: this.cartService.idCart,
              countryIsoCode: this.getAddressDelivery?.CountryIsoCode,
              country: this.getAddressDelivery?.Country,
              onSuccess: (data) => {
                if (this.carrierTypes) {
                  this.carriersService.fetchCarriers({
                    idAddress: this.idAddressDelivery,
                    idCart: this.cartService.idCart,
                    countryIsoCode: this.getAddressDelivery?.CountryIsoCode,
                    country: this.getAddressDelivery?.Country,
                    carrierType: this.carrierTypes[0],
                    responseLevel: 'details',
                  });

                  this.$store.commit(
                    'carriers/setActiveTab',
                    this.carrierTypes[0]
                  );
                }
              },
            });
          }
        },
      });
    },
    addressValidate() {
      if (this.$refs['addressDeliveryInvoiceRef']) {
        const isOk = this.$refs['addressDeliveryInvoiceRef'].valide;
        this.addressesError = !isOk;
        return isOk;
      }
      return false;
    },
    async next() {
      if (!this.isCartValid) return;
      let isOk = true;
      this.optioDeliveryError = false;
      this.addressesError = false;

      if (!this.addressValidate()) {
        isOk = false;
        this.addressesError = true;
      }

      if (!this.carrier && !this.isDigitalCart) {
        isOk = false;
        this.optioDeliveryError = true;
      }

      if (isOk) {
        this.$router.push(this.localePath('/cart/payment'));

        // this.$gtag.event('add_shipping_info', {
        //   shipping_tier: this.carrier.Name,
        //   value: this.deliveryFees,
        // });

        // this.$gtm.push({
        //   event: 'add_shipping_info',
        //   ecommerce: {
        //     currency: this.$localisation.appCurrency.CurrencyIsoCode,
        //     shipping_tier: this.carrier.Name,
        //     value: this.deliveryFees,
        //   },
        // });

        this.addShippingInfoGtm();
      }
    },
    scrollTo(ref) {
      window.scrollTo({
        top: this.$refs[ref].offsetTop - 146,
        behavior: 'smooth',
      });
    },
    fetshCarriers() {
      this.carriersService.fetchCarrierTypes({
        idAddress: this.idAddressDelivery,
        idCart: this.cartService.idCart,
        countryIsoCode: this.getAddressDelivery?.CountryIsoCode,
        country: this.getAddressDelivery?.Country,
        onSuccess: (data) => {
          if (this.carrierTypes) {
            this.carriersService.fetchCarriers({
              idAddress: this.idAddressDelivery,
              idCart: this.cartService.idCart,
              countryIsoCode: this.getAddressDelivery?.CountryIsoCode,
              country: this.getAddressDelivery?.Country,
              carrierType: this.carrierTypes[0],
              responseLevel: 'details',
            });
            this.$store.commit('carriers/setActiveTab', this.carrierTypes[0]);
            this.isOpenAddAddress = false;
          }
        },
      });
    },
  },
  components: {
    CartItems,
    PackageIcon,
    CreditCardIcon,
    PlusIcon,
    HomeIcon,
    MapPinIcon,
    Progress,
    Tabs,
    TabPane,
    Button,
    TotalOrder,
    CardInfo,
    TunnelOrderLayout,
    AddessForm,
    ClockIcon,
    Select,
    Option,
    Checkbox,
    AddressDeliveryInvoice,
    DeliverySelected,
    DeliveryTabs,
    MiniCart,
    ErrorsMsgs,
    ChevronLeftIcon,
    RegisterFormInfoGuest,
    CodePromo2,
    Tooltip,
  },
};
